import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { mensagemCampoObrigatorio } from '@core/util/mensagemUtil';
import { Grid } from '@material-ui/core';
import TabDadosFiscaisProduto from 'app/main/produto/components/modal/CadastroProdutoModal/TabDadosFiscaisProduto';
import { cancelarAlert } from 'app/services/alerts';
import empresaApi from 'app/services/api/empresaApi';
import { GlobalContext } from 'app/store/globalcontext';
import { getEmpresaContexto } from 'app/utils/geralUtil';
import { FormikProvider, useFormik } from 'formik';
import React, { useContext, useEffect, useState } from 'react';
import { MdSettings } from 'react-icons/md';
import * as Yup from 'yup';

const AtualizarAliquotaModal = ({
  modalAtualizarAliquota,
  setModalAtualizarAliquota,
  onSubmit,
  produtoServico,
  props,
  isVenda,
}) => {
  const [produto, setProduto] = useState({});
  const [, setPossuiIcms] = useContext(GlobalContext).possuiIcms;
  const [possuiIpi, setPossuiIpi] = useContext(GlobalContext).possuiIpi;
  const [empresaIbsCbs, setEmpresaIbsCbs] = useState(false);

  const produtoSelecionado = produtoServico?.produtoServico;

  useEffect(() => {
    if (modalAtualizarAliquota === 'atualizarAliquota') {
      setProduto(produtoSelecionado);
      formik.setValues({ ...produtoServico });
      setPossuiIcms(produtoSelecionado?.fiscal?.icms?.possuiIcms);
      setPossuiIpi(produtoSelecionado?.fiscal?.ipi?.possuiIpi);
    }
    // Reset controlado pelo gatilho acima; incluir o formulário/valores reiniciaria o
    // preenchimento enquanto o usuário edita.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalAtualizarAliquota]);

  useEffect(() => {
    const carregarEmpresaIbsCbs = async () => {
      try {
        const empresa = await empresaApi.buscar(getEmpresaContexto());
        if (
          empresa?.data?.ibsCbs &&
          (empresa?.data?.contribuinteIbs || empresa?.data?.contribuinteCbs || empresa?.data?.contribuinteIs)
        ) {
          formik.values.fiscal.ibsCbs = true;
          setEmpresaIbsCbs(true);
        }
      } catch (error) {
        setEmpresaIbsCbs(false);
      }
    };
    carregarEmpresaIbsCbs();
    // Efeito de montagem: roda uma única vez. Incluir as dependências reexecutaria a carga
    // inicial a cada render (loop de chamadas à API).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let initialValues = {
    fiscal: {
      id: produtoServico?.fiscal?.id,
      codigoNCM: produtoServico?.fiscal?.codigoNCM || null,
      cfop: produtoServico?.fiscal?.cfop || null,
      cest: produtoServico?.fiscal?.cest || null,
      tipoUnidadeMedida: produtoServico?.fiscal?.tipoUnidadeMedida || 'VAZIO',
      pesoLiquido: produtoServico?.fiscal?.pesoLiquido || null,
      pesoBruto: produtoServico?.fiscal?.pesoBruto || null,
      altura: produtoServico?.fiscal?.altura || null,
      largura: produtoServico?.fiscal?.largura || null,
      profundidade: produtoServico?.fiscal?.profundidade || null,
      origemProduto: produtoServico?.fiscal?.origemProduto || null,
      numeroPedidoCompra: produtoServico?.fiscal?.numeroPedidoCompra || null,
      numeroItemPedidoCompra: produtoServico?.fiscal?.numeroItemPedidoCompra || null,
      icms: {
        situacaoTributaria: produtoServico?.fiscal?.icms?.situacaoTributaria || null,
        codigoTributario: produtoServico?.fiscal?.icms?.codigoTributario || null,
        motivoDesoneracao: produtoServico?.fiscal?.icms?.motivoDesoneracao || null,
        possuiIcms: produtoServico?.fiscal?.icms?.possuiIcms || false,
        ufIcmsStDevido: produtoServico?.fiscal?.icms?.ufIcmsStDevido || null,
        modalidadeDeterminacaoBcIcmsST: produtoServico?.fiscal?.icms?.modalidadeDeterminacaoBcIcmsST || null,
        modalidadeDeterminacaoBC: produtoServico?.fiscal?.icms?.modalidadeDeterminacaoBC || null,
        reducaoBC: produtoServico?.fiscal?.icms?.reducaoBC || null,
        valorBC: produtoServico?.fiscal?.icms?.valorBC || null,
        aliquotaImposto: produtoServico?.fiscal?.icms?.aliquotaImposto || null,
        aliquotaRelativoFcp: produtoServico?.fiscal?.icms?.aliquotaRelativoFcp || null,
        valorBcFcp: produtoServico?.fiscal?.icms?.valorBcFcp || null,
        reducaoBcIcmsSt: produtoServico?.fiscal?.icms?.reducaoBcIcmsSt || null,
        mvaIcmsSt: produtoServico?.fiscal?.icms?.mvaIcmsSt || null,
        aliquotaImpostoIcmsSt: produtoServico?.fiscal?.icms?.aliquotaImpostoIcmsSt || null,
        valorBcFcpRetidoSt: produtoServico?.fiscal?.icms?.valorBcFcpRetidoSt || null,
        fcpRetidoSt: produtoServico?.fiscal?.icms?.fcpRetidoSt || null,
        reducaoBCEfetiva: produtoServico?.fiscal?.icms?.reducaoBCEfetiva || null,
        valorDesoneracao: produtoServico?.fiscal?.icms?.valorDesoneracao || null,
        valorBcIcmsSt: produtoServico?.fiscal?.icms?.valorBcIcmsSt || null,
        valorIcmsOperacao: produtoServico?.fiscal?.icms?.valorIcmsOperacao || null,
        diferimento: produtoServico?.fiscal?.icms?.diferimento || null,
        valorBcIcmsStRetido: produtoServico?.fiscal?.icms?.valorBcIcmsStRetido || null,
        aliquotaSuportadaConsumidorFinal: produtoServico?.fiscal?.icms?.aliquotaSuportadaConsumidorFinal || null,
        valorIcmsStRetido: produtoServico?.fiscal?.icms?.valorIcmsStRetido || null,
        valorIcmsProprioSubstituto: produtoServico?.fiscal?.icms?.valorIcmsProprioSubstituto || null,
        valorBcFcpRetidoAnteriormenteSt: produtoServico?.fiscal?.icms?.valorBcFcpRetidoAnteriormenteSt || null,
        fcpRetidoAnteriormenteSt: produtoServico?.fiscal?.icms?.fcpRetidoAnteriormenteSt || null,
        valorBCEfetiva: produtoServico?.fiscal?.icms?.valorBCEfetiva || null,
        aliquotaIcmsEfetiva: produtoServico?.fiscal?.icms?.aliquotaIcmsEfetiva || null,
        aliquotaAplicavelCalculoCredito: produtoServico?.fiscal?.icms?.aliquotaAplicavelCalculoCredito || null,
        valorCreditoIcms: produtoServico?.fiscal?.icms?.valorCreditoIcms || null,
        bcOperacaoPropria: produtoServico?.fiscal?.icms?.bcOperacaoPropria || null,
      },
      ipi: {
        situacaoTributaria: produtoServico?.fiscal?.ipi?.situacaoTributaria || null,
        codigoEnquadramento: produtoServico?.fiscal?.ipi?.codigoEnquadramento || null,
        aliquota: produtoServico?.fiscal?.ipi?.aliquota || null,
        valorBc: produtoServico?.fiscal?.ipi?.valorBc || null,
        tributacaoExclusivaPorUnidade: produtoServico?.fiscal?.ipi?.tributacaoExclusivaPorUnidade || null,
      },
    },
  };

  const handleClose = () => {
    if (formik.dirty) {
      cancelarAlert({
        confirmar: close,
      });
    } else {
      close();
    }
  };
  const schema = Yup.object().shape({
    fiscal: Yup.object().shape({
      pesoBruto: Yup.number().nullable(),
      origemProduto: Yup.object()
        .nullable()
        .test('validaOrigemProduto', mensagemCampoObrigatorio('Origem do produto'), () => {
          return !(formik.values?.fiscal?.icms?.possuiIcms && !formik.values?.fiscal?.origemProduto?.id);
        }),
      icms: Yup.object().shape({
        situacaoTributaria: Yup.object()
          .nullable()
          .test('validaSituacaoTributaria', mensagemCampoObrigatorio('Situação tributária'), () => {
            return !(formik.values?.fiscal?.icms?.possuiIcms && !formik.values?.fiscal?.icms?.situacaoTributaria?.id);
          }),
        modalidadeDeterminacaoBcIcmsST: Yup.string()
          .nullable()
          .test(
            'validaModalidadeDeterminacaoBcIcmsST',
            mensagemCampoObrigatorio('Modalidade de determinação da BC do ICMS ST'),
            function(modalidadeDeterminacaoBcIcmsST) {
              const { codigoTributario } = this.parent;

              if (codigoTributario === '90' || codigoTributario === '900') {
                if (this.parent.valorBcIcmsSt === '0') {
                  return true;
                }
                if (this.parent.aliquotaImpostoIcmsSt === '0') {
                  return true;
                }
                if (this.parent.bcOperacaoPropria === '0') {
                  return true;
                }
                if (
                  codigoTributario === '90' &&
                  (this.parent.valorBcIcmsSt || this.parent.aliquotaImpostoIcmsSt) &&
                  !modalidadeDeterminacaoBcIcmsST
                ) {
                  return false;
                }
                if (
                  codigoTributario === '900' &&
                  (this.parent.valorBcIcmsSt ||
                    this.parent.aliquotaImpostoIcmsSt ||
                    this.parent.bcOperacaoPropria ||
                    this.parent.ufIcmsStDevido?.id) &&
                  !modalidadeDeterminacaoBcIcmsST
                ) {
                  return false;
                }
                return true;
              }
              return validaCamposIcms(formik.values?.fiscal?.icms?.modalidadeDeterminacaoBcIcmsST, [
                '10',
                '30',
                '70',
                '201',
                '202',
                '203',
              ]);
            }
          ),
        modalidadeDeterminacaoBC: Yup.string()
          .nullable()
          .test(
            'validaModalidadeDeterminacaoBC',
            mensagemCampoObrigatorio('Modalidade de determinação da BC'),
            function(modalidadeDeterminacaoBC) {
              const { codigoTributario } = this.parent;

              if (codigoTributario === '90' || codigoTributario === '900') {
                if (this.parent.valorBC === '0') {
                  return true;
                }
                if (this.parent.aliquotaImposto === '0') {
                  return true;
                }
                if ((this.parent.valorBC || this.parent.aliquotaImposto) && !modalidadeDeterminacaoBC) {
                  return false;
                }
                return true;
              }
              return validaCamposIcms(formik.values?.fiscal?.icms?.modalidadeDeterminacaoBC, ['00', '10', '20']);
            }
          ),
        valorBC: Yup.string()
          .nullable()
          .test('validaValorBC', mensagemCampoObrigatorio('Valor da BC (R$)'), function(valorBC) {
            const codigoTributario = this.parent.situacaoTributaria?.codigo;

            if (!codigoTributario) return true;

            if (codigoTributario === '90' || codigoTributario === '900') {
              if (this.parent.aliquotaImposto === '0') {
                return true;
              }
              if ((this.parent.modalidadeDeterminacaoBC || this.parent.aliquotaImposto) && !valorBC) {
                return false;
              }
              return true;
            }
            return validaCamposIcms(formik.values?.fiscal?.icms?.valorBC, ['00', '10', '20', '70']);
          }),
        aliquotaImposto: Yup.string()
          .nullable()
          .test('validaAliquotaImposto', mensagemCampoObrigatorio('Alíquota do imposto (%)'), function(
            aliquotaImposto
          ) {
            const codigoTributario = this.parent.situacaoTributaria?.codigo;

            if (!codigoTributario) return true;

            if (codigoTributario === '90' || codigoTributario === '900') {
              if (this.parent.valorBC === '0') {
                return true;
              }
              if ((this.parent.modalidadeDeterminacaoBC || this.parent.valorBC) && !aliquotaImposto) {
                return false;
              }
              return true;
            }
            return validaCamposIcms(formik.values?.fiscal?.icms?.aliquotaImposto, ['00', '10', '20', '70']);
          }),
        aliquotaImpostoIcmsSt: Yup.string()
          .nullable()
          .test('validaAliquotaImpostoIcmsSt', mensagemCampoObrigatorio('Alíquota do imposto do ICMS ST (%)'), function(
            aliquotaImpostoIcmsSt
          ) {
            const codigoTributario = this.parent.situacaoTributaria?.codigo;

            if (!codigoTributario) return true;

            if (codigoTributario === '90' || codigoTributario === '900') {
              if (this.parent.valorBcIcmsSt === '0') {
                return true;
              }
              if (this.parent.bcOperacaoPropria === '0') {
                return true;
              }
              if (
                codigoTributario === '90' &&
                (this.parent.modalidadeDeterminacaoBcIcmsST || this.parent.valorBcIcmsSt) &&
                !aliquotaImpostoIcmsSt
              ) {
                return false;
              }
              if (
                codigoTributario === '900' &&
                (this.parent.modalidadeDeterminacaoBcIcmsST ||
                  this.parent.valorBcIcmsSt ||
                  this.parent.bcOperacaoPropria ||
                  this.parent.ufIcmsStDevido?.id) &&
                !aliquotaImpostoIcmsSt
              ) {
                return false;
              }
              return true;
            }
            return validaCamposIcms(formik.values?.fiscal?.icms?.aliquotaImpostoIcmsSt, [
              '10',
              '30',
              '70',
              '201',
              '202',
              '203',
            ]);
          }),
        reducaoBC: Yup.string()
          .nullable()
          .test('validaReducaoBC', mensagemCampoObrigatorio('Redução de BC (%)'), () => {
            return validaCamposIcms(formik.values?.fiscal?.icms?.reducaoBC, ['20', '70']);
          }),
        valorBcIcmsSt: Yup.string()
          .nullable()
          .test('validaValorBcIcmsSt', mensagemCampoObrigatorio('Valor da BC do ICMS ST (R$)'), function(
            valorBcIcmsSt
          ) {
            const codigoTributario = this.parent.situacaoTributaria?.codigo;

            if (!codigoTributario) return true;

            if (codigoTributario === '90' || codigoTributario === '900') {
              if (this.parent.aliquotaImpostoIcmsSt === '0') {
                return true;
              }
              if (this.parent.bcOperacaoPropria === '0') {
                return true;
              }
              if (
                codigoTributario === '90' &&
                (this.parent.modalidadeDeterminacaoBcIcmsST || this.parent.aliquotaImpostoIcmsSt) &&
                !valorBcIcmsSt
              ) {
                return false;
              }
              if (
                codigoTributario === '900' &&
                (this.parent.modalidadeDeterminacaoBcIcmsST ||
                  this.parent.aliquotaImpostoIcmsSt ||
                  this.parent.bcOperacaoPropria ||
                  this.parent.ufIcmsStDevido?.id) &&
                !valorBcIcmsSt
              ) {
                return false;
              }
              return true;
            }
            return validaCamposIcms(formik.values?.fiscal?.icms?.valorBcIcmsSt, [
              '10',
              '30',
              '70',
              '201',
              '202',
              '203',
            ]);
          }),
        aliquotaAplicavelCalculoCredito: Yup.string()
          .nullable()
          .test(
            'validaAliquotaAplicavelCalculoCredito',
            mensagemCampoObrigatorio('Alíquota aplicável de cálculo de crédito (%)'),
            function(aliquotaAplicavelCalculoCredito) {
              const codigoTributario = this.parent.situacaoTributaria?.codigo;

              if (!codigoTributario) return true;

              if (codigoTributario === '201') {
                if (this.parent.valorBcFcpRetidoSt === '0') {
                  return true;
                }
                if (this.parent.fcpRetidoSt === '0') {
                  return true;
                }
                if (this.parent.valorCreditoIcms === '0') {
                  return true;
                }
                if (
                  (this.parent.valorBcFcpRetidoSt || this.parent.fcpRetidoSt || this.parent.valorCreditoIcms) &&
                  !aliquotaAplicavelCalculoCredito
                ) {
                  return false;
                }
                return true;
              }
              if (codigoTributario === '900') {
                if (this.parent.valorCreditoIcms === '0') {
                  return true;
                }
                if (this.parent.valorCreditoIcms && !aliquotaAplicavelCalculoCredito) {
                  return false;
                }
                return true;
              }
              return validaCamposIcms(formik.values?.fiscal?.icms?.aliquotaAplicavelCalculoCredito, ['101']);
            }
          ),
        valorCreditoIcms: Yup.string()
          .nullable()
          .test('validaValorCreditoIcms', mensagemCampoObrigatorio('Valor de crédito do ICMS (R$)'), function(
            valorCreditoIcms
          ) {
            const codigoTributario = this.parent.situacaoTributaria?.codigo;

            if (!codigoTributario) return true;

            if (codigoTributario === '201') {
              if (this.parent.valorBcFcpRetidoSt === '0') {
                return true;
              }
              if (this.parent.fcpRetidoSt === '0') {
                return true;
              }
              if (this.parent.aliquotaAplicavelCalculoCredito === '0') {
                return true;
              }
              if (
                (this.parent.valorBcFcpRetidoSt ||
                  this.parent.fcpRetidoSt ||
                  this.parent.aliquotaAplicavelCalculoCredito) &&
                !valorCreditoIcms
              ) {
                return false;
              }
              return true;
            }
            if (codigoTributario === '900') {
              if (this.parent.aliquotaAplicavelCalculoCredito === '0') {
                return true;
              }
              if (this.parent.aliquotaAplicavelCalculoCredito && !valorCreditoIcms) {
                return false;
              }
              return true;
            }
            return validaCamposIcms(formik.values?.fiscal?.icms?.valorCreditoIcms, ['101']);
          }),
        valorBcFcp: Yup.string()
          .nullable()
          .test('validaValorBcFcp', mensagemCampoObrigatorio('Valor da BC do FCP (R$) '), function(valorBcFcp) {
            const codigoTributario = this.parent.situacaoTributaria?.codigo;

            if (!codigoTributario) return true;

            if (codigoTributario !== '00') {
              if (this.parent.aliquotaRelativoFcp === '0') {
                return true;
              }
              if (this.parent.aliquotaRelativoFcp && !valorBcFcp) {
                return false;
              }
              return true;
            }
            return true;
          }),

        aliquotaRelativoFcp: Yup.string()
          .nullable()
          .test('validaAliquotaRelativoFcp', mensagemCampoObrigatorio('Alíquota relativo ao FCP (%)'), function(
            aliquotaRelativoFcp
          ) {
            const codigoTributario = this.parent.situacaoTributaria?.codigo;

            if (!codigoTributario) return true;

            if (codigoTributario !== '00') {
              if (this.parent.valorBcFcp === '0') {
                return true;
              }
              if (this.parent.valorBcFcp && !aliquotaRelativoFcp) {
                return false;
              }
              return true;
            }
            return true;
          }),
        valorBcFcpRetidoSt: Yup.string()
          .nullable()
          .test('validaValorBcFcpRetidoSt', mensagemCampoObrigatorio('Valor da BC do FCP retido por ST (R$)'), function(
            valorBcFcpRetidoSt
          ) {
            const codigoTributario = this.parent.situacaoTributaria?.codigo;

            if (!codigoTributario) return true;

            if (codigoTributario !== '101' && codigoTributario !== '900') {
              if (this.parent.fcpRetidoSt === '0') {
                return true;
              }
              if (this.parent.aliquotaAplicavelCalculoCredito === '0') {
                return true;
              }
              if (this.parent.valorCreditoIcms === '0') {
                return true;
              }
              if (
                (this.parent.fcpRetidoSt ||
                  this.parent.aliquotaAplicavelCalculoCredito ||
                  this.parent.valorCreditoIcms) &&
                !valorBcFcpRetidoSt
              ) {
                return false;
              }
              return true;
            }
            if (codigoTributario === '900') {
              if (this.parent.fcpRetidoSt === '0') {
                return true;
              }
              if (this.parent.fcpRetidoSt && !valorBcFcpRetidoSt) {
                return false;
              }
              return true;
            }
            return true;
          }),
        fcpRetidoSt: Yup.string()
          .nullable()
          .test('validaFcpRetidoSt', mensagemCampoObrigatorio('FCP retido por ST (%)'), function(fcpRetidoSt) {
            const codigoTributario = this.parent.situacaoTributaria?.codigo;

            if (!codigoTributario) return true;

            if (codigoTributario !== '101' && codigoTributario !== '900') {
              if (this.parent.valorBcFcpRetidoSt === '0') {
                return true;
              }
              if (this.parent.aliquotaAplicavelCalculoCredito === '0') {
                return true;
              }
              if (this.parent.valorCreditoIcms === '0') {
                return true;
              }
              if (
                (this.parent.valorBcFcpRetidoSt ||
                  this.parent.aliquotaAplicavelCalculoCredito ||
                  this.parent.valorCreditoIcms) &&
                !fcpRetidoSt
              ) {
                return false;
              }
              return true;
            }
            if (codigoTributario === '900') {
              if (this.parent.valorBcFcpRetidoSt === '0') {
                return true;
              }
              if (this.parent.valorBcFcpRetidoSt && !fcpRetidoSt) {
                return false;
              }
              return true;
            }
            return true;
          }),
        valorDesoneracao: Yup.string()
          .nullable()
          .test('validaValorDesoneracao', mensagemCampoObrigatorio('Valor da desoneração (R$)'), function(
            valorDesoneracao
          ) {
            if (this.parent.motivoDesoneracao?.id && !valorDesoneracao) {
              return false;
            }
            return true;
          }),
        motivoDesoneracao: Yup.object()
          .nullable()
          .test('validaMotivoDesoneracao', mensagemCampoObrigatorio('Motivo da desoneração'), function(
            motivoDesoneracao
          ) {
            if (this.parent.valorDesoneracao === '0') {
              return true;
            }
            if (this.parent.valorDesoneracao && !motivoDesoneracao?.id) {
              return false;
            }
            return true;
          }),
        valorBcIcmsStRetido: Yup.string()
          .nullable()
          .test('validaValorBcIcmsStRetido', mensagemCampoObrigatorio('Valor da BC do ICMS ST retido (R$)'), function(
            valorBcIcmsStRetido
          ) {
            if (this.parent.aliquotaSuportadaConsumidorFinal === '0') {
              return true;
            }
            if (this.parent.valorIcmsStRetido === '0') {
              return true;
            }
            if (
              (this.parent.aliquotaSuportadaConsumidorFinal || this.parent.valorIcmsStRetido) &&
              !valorBcIcmsStRetido
            ) {
              return false;
            }
            return true;
          }),
        aliquotaSuportadaConsumidorFinal: Yup.string()
          .nullable()
          .test(
            'validaAliquotaSuportadaConsumidorFinal',
            mensagemCampoObrigatorio('Alíquota suportada pelo Consumidor Final (%)'),
            function(aliquotaSuportadaConsumidorFinal) {
              if (this.parent.valorBcIcmsStRetido === '0') {
                return true;
              }
              if (this.parent.valorIcmsStRetido === '0') {
                return true;
              }
              if (
                (this.parent.valorBcIcmsStRetido || this.parent.valorIcmsStRetido) &&
                !aliquotaSuportadaConsumidorFinal
              ) {
                return false;
              }
              return true;
            }
          ),
        valorIcmsStRetido: Yup.string()
          .nullable()
          .test('validaValorIcmsStRetido', mensagemCampoObrigatorio('Valor do ICMS ST retido (R$)'), function(
            valorIcmsStRetido
          ) {
            if (this.parent.valorBcIcmsStRetido === '0') {
              return true;
            }
            if (this.parent.aliquotaSuportadaConsumidorFinal === '0') {
              return true;
            }
            if (
              (this.parent.valorBcIcmsStRetido || this.parent.aliquotaSuportadaConsumidorFinal) &&
              !valorIcmsStRetido
            ) {
              return false;
            }
            return true;
          }),
        valorBcFcpRetidoAnteriormenteSt: Yup.string()
          .nullable()
          .test(
            'validaValorBcFcpRetidoAnteriormenteSt',
            mensagemCampoObrigatorio('Valor da BC do FCP retido anteriormente por ST (R$)'),
            function(valorBcFcpRetidoAnteriormenteSt) {
              if (this.parent.fcpRetidoAnteriormenteSt === '0') {
                return true;
              }
              if (this.parent.fcpRetidoAnteriormenteSt && !valorBcFcpRetidoAnteriormenteSt) {
                return false;
              }
              return true;
            }
          ),
        fcpRetidoAnteriormenteSt: Yup.string()
          .nullable()
          .test(
            'validaValorBcFcpRetidoAnteriormenteSt',
            mensagemCampoObrigatorio('FCP retido anteriormente por ST (%)'),
            function(fcpRetidoAnteriormenteSt) {
              if (this.parent.valorBcFcpRetidoAnteriormenteSt === '0') {
                return true;
              }
              if (this.parent.valorBcFcpRetidoAnteriormenteSt && !fcpRetidoAnteriormenteSt) {
                return false;
              }
              return true;
            }
          ),
        valorBCEfetiva: Yup.string()
          .nullable()
          .test('validaValorBCEfetiva', mensagemCampoObrigatorio('Valor da BC efetiva (R$)'), function(valorBCEfetiva) {
            if (this.parent.reducaoBCEfetiva === '0') {
              return true;
            }
            if (this.parent.aliquotaIcmsEfetiva === '0') {
              return true;
            }
            if ((this.parent.reducaoBCEfetiva || this.parent.aliquotaIcmsEfetiva) && !valorBCEfetiva) {
              return false;
            }
            return true;
          }),
        reducaoBCEfetiva: Yup.string()
          .nullable()
          .test('validaReducaoBCEfetiva', mensagemCampoObrigatorio('Redução da BC efetiva (%)'), function(
            reducaoBCEfetiva
          ) {
            if (this.parent.valorBCEfetiva === '0') {
              return true;
            }
            if (this.parent.aliquotaIcmsEfetiva === '0') {
              return true;
            }
            if ((this.parent.valorBCEfetiva || this.parent.aliquotaIcmsEfetiva) && !reducaoBCEfetiva) {
              return false;
            }
            return true;
          }),
        aliquotaIcmsEfetiva: Yup.string()
          .nullable()
          .test('validaAliquotaIcmsEfetiva', mensagemCampoObrigatorio('Alíquota do ICMS efetiva (%)'), function(
            aliquotaIcmsEfetiva
          ) {
            if (this.parent.valorBCEfetiva === '0') {
              return true;
            }
            if (this.parent.reducaoBCEfetiva === '0') {
              return true;
            }
            if ((this.parent.valorBCEfetiva || this.parent.reducaoBCEfetiva) && !aliquotaIcmsEfetiva) {
              return false;
            }
            return true;
          }),
        bcOperacaoPropria: Yup.string()
          .nullable()
          .test('validaBcOperacaoPropria', mensagemCampoObrigatorio('BC da operação própria (%)'), function(
            bcOperacaoPropria
          ) {
            const codigoTributario = this.parent.situacaoTributaria?.codigo;

            if (!codigoTributario) return true;

            if (this.parent.valorBcIcmsSt === '0') {
              return true;
            }
            if (this.parent.aliquotaImpostoIcmsSt === '0') {
              return true;
            }
            if (
              codigoTributario === '900' &&
              (this.parent.modalidadeDeterminacaoBcIcmsST ||
                this.parent.valorBcIcmsSt ||
                this.parent.aliquotaImpostoIcmsSt ||
                this.parent.ufIcmsStDevido?.id) &&
              !bcOperacaoPropria
            ) {
              return false;
            }
            return true;
          }),
        ufIcmsStDevido: Yup.object()
          .nullable()
          .test('validaUfIcmsStDevido', mensagemCampoObrigatorio('UF para qual é devido o ICMS ST'), function(
            ufIcmsStDevido
          ) {
            const codigoTributario = this.parent.situacaoTributaria?.codigo;

            if (!codigoTributario) return true;

            if (this.parent.valorBcIcmsSt === '0') {
              return true;
            }
            if (this.parent.aliquotaImpostoIcmsSt === '0') {
              return true;
            }
            if (this.parent.bcOperacaoPropria === '0') {
              return true;
            }
            if (
              codigoTributario === '900' &&
              (this.parent.modalidadeDeterminacaoBcIcmsST ||
                this.parent.valorBcIcmsSt ||
                this.parent.aliquotaImpostoIcmsSt ||
                this.parent.bcOperacaoPropria) &&
              !ufIcmsStDevido?.id
            ) {
              return false;
            }
            return true;
          }),
      }),
      ipi: Yup.object().shape({
        situacaoTributaria: Yup.object()
          .nullable()
          .test('situacaoTributaria', mensagemCampoObrigatorio('a situação tributária'), () => {
            return !(possuiIpi && !formik.values?.fiscal?.ipi?.situacaoTributaria?.id);
          }),
        codigoEnquadramento: Yup.string()
          .nullable()
          .test('codigoEnquadramento', mensagemCampoObrigatorio('o código de enquadramento'), () => {
            return !(
              possuiIpi &&
              formik.values?.fiscal?.ipi?.situacaoTributaria?.id &&
              !formik.values?.fiscal?.ipi?.codigoEnquadramento
            );
          }),
      }),
    }),
  });

  const formik = useFormik({
    validationSchema: schema,
    initialValues,
    onSubmit: onSubmit,
    validateOnChange: true,
    validateOnBlur: true,
  });

  const close = () => {
    formik.setValues({});
    setModalAtualizarAliquota('');
  };

  const validaCamposIcms = (campo, codigos) => {
    const icms = formik.values?.fiscal?.icms;

    if (icms && icms?.possuiIcms && codigos.indexOf(icms?.situacaoTributaria?.codigo) !== -1 && campo) {
      return true;
    }
    if (icms && icms?.possuiIcms && codigos.indexOf(icms?.situacaoTributaria?.codigo) === -1) {
      return true;
    }
    if ((icms && !icms?.possuiIcms) || !icms?.situacaoTributaria?.codigo) {
      return true;
    }
    return false;
  };

  return (
    <>
      {produto ? (
        <SimpleDialog
          fullScreen
          open={modalAtualizarAliquota === 'atualizarAliquota'}
          onClose={handleClose}
          innerScroll
        >
          <FormikProvider value={formik}>
            <FormDialogContent
              onSubmit={(e) => {
                formik.handleSubmit();
              }}
              fullScreen
              header={{
                title: 'Atualizar alíquotas',
                icon: <MdSettings />,
                toolbar: (
                  <>
                    <CancelButton title="cancelar" type="button" onClick={handleClose}>
                      Cancelar
                    </CancelButton>
                    <SaveButton color="buttonSave" type="submit" styles={undefined} variant={'contained'}>
                      Salvar
                    </SaveButton>
                  </>
                ),
              }}
              content={
                <>
                  <div className="h-full max-h-full w-full">
                    <Grid container>
                      <Grid item lg={3} md={3} sm={3} xs={3}>
                        <label>
                          <b>Nome do produto</b>
                        </label>
                      </Grid>
                      <Grid item lg={3} md={3} sm={3} xs={3}>
                        <label>
                          <b>Código do produto (SKU)</b>
                        </label>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <label>
                          <b>Descrição detalhada do produto</b>
                        </label>
                      </Grid>
                    </Grid>
                    <Grid container>
                      <Grid item lg={3} md={3} sm={3} xs={3}>
                        {produto?.nome ? produto?.nome : '-'}
                      </Grid>
                      <Grid item lg={3} md={3} sm={3} xs={3}>
                        {produto?.codigo ? produto?.codigo : '-'}
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        {produto?.descricaoDetalhada ? produto?.descricaoDetalhada : '-'}
                      </Grid>
                    </Grid>
                    <TabDadosFiscaisProduto
                      camposMedidas={false}
                      esconderCamposIcms={props.esconderCamposIcms}
                      isAtualizarAliquota={true}
                      isVenda={isVenda}
                      empresaIbsCbs={empresaIbsCbs}
                    />
                  </div>
                </>
              }
            />
          </FormikProvider>
        </SimpleDialog>
      ) : null}
    </>
  );
};

export default AtualizarAliquotaModal;
